// GERADO de backend-senne/src/contracts — NÃO editar; rode scripts/sync-contracts.sh

import { z } from 'zod'

/** CPF: normaliza removendo não-dígitos; exige exatamente 11 dígitos. */
export const cpfSchema = z
  .string()
  .transform((s) => s.replace(/\D/g, ''))
  .pipe(z.string().regex(/^\d{11}$/, 'CPF deve ter 11 dígitos'))

/** E-mail: trim + lowercase, depois valida formato. */
export const emailSchema = z.string().trim().toLowerCase().pipe(z.string().email())

/** Data ISO 8601 com offset (ex.: 2026-06-22T12:00:00-03:00). */
export const isoDateSchema = z.string().datetime({ offset: true })

/** Contato parcialmente mascarado devolvido antes do OTP (telefone/e-mail). */
export const maskedContactSchema = z.string().min(1)
export type MaskedContact = z.infer<typeof maskedContactSchema>
